import { useNavigate } from 'react-router-dom';
import { ReactComponent as InfoIcon } from 'assets/icons/information_mark.svg';
import * as S from './EditConfirmationModal.styled';
import { Colors } from 'styles/variables/colors';

const { darkGray } = Colors;

type Props = {
    closeModal: () => void;
};

const EditConfirmationModal = ({ closeModal }: Props) => {
    const navigate = useNavigate();
    return (
        <S.ModalContainer>
            <S.TopContainer>
                <S.InfoIconContainer>
                    <InfoIcon fill={darkGray} style={{ height: 26.6, width: 26.6 }} />
                </S.InfoIconContainer>
            </S.TopContainer>
            <S.Message>
                Editing your Assessment questionnaire will result in different Visa options. Please
                be sure your provide accurate and precise information. Otherwise, you will disrupt
                your visa application and the accuracy of the consulation.
            </S.Message>
            <S.BottomContainer>
                <S.Button secondary={true} onClick={() => closeModal()}>
                    Cancel
                </S.Button>
                <S.Button secondary={false} type="submit" onClick={() => navigate('/assessment')}>
                    Edit
                </S.Button>
            </S.BottomContainer>
        </S.ModalContainer>
    );
};
export default EditConfirmationModal;
